// **********************************************************
// Image Gallery
// **********************************************************

const imageGalleryItems = document.querySelectorAll('.image-gallery__item');

if (imageGalleryItems) {
  imageGalleryItems.forEach((ele) => {
    const parentElem = ele.closest('.image-gallery');
    const trackEle = parentElem.querySelector('.image-gallery__track');
    const totalItems = parentElem.querySelectorAll('.image-gallery__item').length;
    parentElem.style.setProperty('--card-count', totalItems);

    ele.addEventListener('mouseover', () => {
      trackEle.style.animationPlayState = 'paused';
    });

    ele.addEventListener('mouseleave', () => {
      trackEle.style.animationPlayState = 'running';
    });
  });
}
